import { 무빈소장2025 } from "./service2025/무빈소장";
import { 가족장2025 } from "./service2025/가족장";
import { 일반장2025 } from "./service2025/일반장";

/** 얘는 현재 기준으로 판매하는 것만 보여야함 */
export const 고이_상품_가격_세자리 = {
  무빈소: 무빈소장2025.가격,
  무빈소장: 무빈소장2025.가격,
  가족장: 가족장2025.가격,
  일반장: 일반장2025.가격,
};

export const 고이_상품_가격 = {
  무빈소: 무빈소장2025.가격 * 10000,
  무빈소장: 무빈소장2025.가격 * 10000,
  가족장: 가족장2025.가격 * 10000,
  일반장: 일반장2025.가격 * 10000,
};
